'use client';

import { createStorefrontClient } from '@shopify/hydrogen-react';
import { TypedDocumentNode } from '@graphql-typed-document-node/core';
import { request } from 'graphql-request';
import { parse } from 'graphql';

export type GqlEdges<T> = {
  edges: { node: T }[];
};

export type CustomerUserError = {
  code: string;
  message: string;
};

export type CustomerAccessToken = {
  accessToken: string;
  expiresAt: string;
};

export const shopClient = createStorefrontClient({
  storeDomain: 'eugenie-detroit.myshopify.com',
  publicStorefrontToken: '3dd3b575a19c0db884f6913fbfe96612',
  storefrontApiVersion: '2025-01',
});

export const shopRequest = async <ResultType>(
  query = '',
  vars: { [key: string]: unknown } = {}
) => {
  const typedQuery: TypedDocumentNode<ResultType> = parse(query);

  try {
    return await request({
      url: shopClient.getStorefrontApiUrl(),
      document: typedQuery,
      variables: {
        ...vars,
      },
      requestHeaders: shopClient.getPublicTokenHeaders(),
    });
  } catch (error) {
    console.log(error);
    const err = error as { response?: { errors?: { message: string }[] } };
    throw new Error(err.response?.errors?.[0]?.message);
  }
};

export const throwUserErrors = (errors: Array<CustomerUserError>) => {
  if (Array.isArray(errors) && errors[0]) {
    const { message, code } = errors[0];
    const error: any = new Error(message);
    error.code = code;
    throw error;
  }
};
